import { render, staticRenderFns } from "./PCard.vue?vue&type=template&id=4e72f8ca&scoped=true&"
import script from "./PCard.vue?vue&type=script&lang=js&"
export * from "./PCard.vue?vue&type=script&lang=js&"
import style0 from "./PCard.vue?vue&type=style&index=0&id=4e72f8ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e72f8ca",
  null
  
)

export default component.exports